import {
    createRouter,
    createWebHistory
} from 'vue-router'
import method from '../methods/method'
import store from '../store'
import {
    getCurrentMenu
} from '../api/public'
const routes = [{
        path: '/login',
        name: 'login',
        component: () => import('../views/login.vue'),
        meta: {
            title: '登录'
        }
    },
    {
        path: '/',
        component: () => import('../views/public.vue'),
    },
    {
        path: '/refresh',
        component: () => import('../views/public.vue'),
        redirect: '/',
        children: [{
            path: '/refresh',
            components: {
                mains: () => import('../views/refresh.vue')
            }
        }, ]
    },
    {
        path: '/system',
        redirect: '/system/roleIndex',
        component: () => import('../views/public.vue'),
        children: [{
            path: '/system/roleIndex',
            meta: {
                title: '角色管理',
                name: 'role',
            },
            components: {
                mains: () => import('../views/system/index.vue')
            }
        }, {
            path: '/system/addRole',
            meta: {
                title: '新增角色'
            },
            components: {
                mains: () => import('../views/system/add.vue')
            }
        }, {
            path: '/system/editRole',
            meta: {
                title: '编辑角色'
            },
            components: {
                mains: () => import('../views/system/add.vue')
            }
        }, {
            path: '/system/userIndex',

            meta: {
                title: '系统用户管理',
                name: 'system_user',
            },
            components: {
                mains: () => import('../views/system/userIndex.vue')
            }
        }, {
            path: '/system/addUser',
            meta: {
                title: '新增用户'
            },
            components: {
                mains: () => import('../views/system/addUser.vue')
            }
        }, {
            path: '/system/menuIndex',
            meta: {
                title: '菜单管理',
                name: 'menus',
            },
            components: {
                mains: () => import('../views/system/menuIndex.vue')
            }
        }, ]
    }, {
        path: '/goods',
        component: () => import('../views/public.vue'),
        redirect: '/goods/classify',
        children: [{
            path: '/goods/classify',
            meta: {
                title: '行业分类',
                name: 'classify'
            },
            components: {
                mains: () => import('../views/goods/classify.vue')
            }
        }]
    }, {
        path: '/merchant',
        component: () => import('../views/public.vue'),
        redirect: '/merchant/index',
        children: [{
            path: '/merchant/index',
            meta: {
                title: '商家管理',
                name: 'merchant',
                keepAlive: true
            },
            components: {
                mains: () => import('../views/merchants/merchant/index.vue')
            }
        }, {
            path: '/merchant/add',
            meta: {
                title: '新增商家'
            },
            components: {
                mains: () => import('../views/merchants/merchant/add.vue')
            }
        }, {
            path: '/merchant/edit',
            meta: {
                title: '编辑商家'
            },
            components: {
                mains: () => import('../views/merchants/merchant/add.vue')
            }
        }, {
            path: '/merchant/info',
            meta: {
                title: '商家详情'
            },
            components: {
                mains: () => import('../views/merchants/merchant/info.vue')
            }
        }, {
            path: '/merchant/examine',
            meta: {
                title: '商家审核'
            },
            components: {
                mains: () => import('../views/merchants/merchant/examine.vue')
            }
        }, {
            path: '/merchant/examineInfo',
            meta: {
                title: '商家审核详情'
            },
            components: {
                mains: () => import('../views/merchants/merchant/examineInfo.vue')
            }
        }, ]
    }, {
        path: '/store',
        component: () => import('../views/public.vue'),
        redirect: '/store/index',
        children: [{
            path: '/store/index',
            meta: {
                title: '门店管理',
                name: 'store',
                keepAlive: true
            },
            components: {
                mains: () => import('../views/merchants/store/index.vue')
            }
        }, {
            path: '/store/add',
            meta: {
                title: '新增门店',
            },
            components: {
                mains: () => import('../views/merchants/store/add.vue')
            }
        }, {
            path: '/store/edit',
            meta: {
                title: '编辑门店',
            },
            components: {
                mains: () => import('../views/merchants/store/add.vue')
            }
        }, {
            path: '/store/info',
            meta: {
                title: '门店详情',
            },
            components: {
                mains: () => import('../views/merchants/store/info.vue')
            }
        }, {
            path: '/store/coupon',
            meta: {
                title: '门店消费券',
                keepAlive: true,
                name: 'store_coupon'
            },
            components: {
                mains: () => import('../views/merchants/store/coupon.vue')
            }
        }, {
            path: '/store/examineInfo',
            meta: {
                title: '门店审核详情',
            },
            components: {
                mains: () => import('../views/merchants/store/examineInfo.vue')
            }
        }, {
            path: '/merchant/account',
            meta: {
                title: '账号管理',
                name: 'merchant_account',
                keepAlive: true
            },
            components: {
                mains: () => import('../views/merchants/account/index.vue')
            }
        }, {
            path: '/merchant/accountAdd',
            meta: {
                title: '新增核销账号',
            },
            components: {
                mains: () => import('../views/merchants/account/add.vue')
            }
        }, {
            path: '/merchant/accountEdit',
            meta: {
                title: '编辑核销账号',
            },
            components: {
                mains: () => import('../views/merchants/account/add.vue')
            }
        }, {
            path: '/merchant/accountInfo',
            meta: {
                title: '核销账号详情',
            },
            components: {
                mains: () => import('../views/merchants/account/info.vue')
            }
        }]
    },
    {
        path: '/salesman',
        component: () => import('../views/public.vue'),
        redirect: '/salesman/index',
        children: [{
            path: '/salesman/index',
            meta: {
                title: '业务员管理',
                keepAlive: true,
                name: 'salesman'
            },
            components: {
                mains: () => import('../views/salesman/index.vue')
            }
        }]
    },
    {
        path: '/coupon',
        component: () => import('../views/public.vue'),
        redirect: '/coupon/index',
        children: [{
            path: '/coupon/index',
            meta: {
                title: '消费券管理',
                keepAlive: true,
                name: 'coupon'
            },
            components: {
                mains: () => import('../views/coupon/index.vue')
            }
        }, {
            path: '/coupon/add',
            meta: {
                title: '新增消费券',
            },
            components: {
                mains: () => import('../views/coupon/add.vue')
            }
        }, {
            path: '/coupon/edit',
            meta: {
                title: '编辑消费券',
            },
            components: {
                mains: () => import('../views/coupon/add.vue')
            }
        }, {
            path: '/coupon/copy',
            meta: {
                title: '复用消费券',
            },
            components: {
                mains: () => import('../views/coupon/add.vue')
            }
        }, {
            path: '/coupon/info',
            meta: {
                title: '消费券详情',
            },
            components: {
                mains: () => import('../views/coupon/info.vue')
            }
        }, {
            path: '/coupon/seeSold',
            meta: {
                title: '已售券查询',
                name: 'sold'
            },
            components: {
                mains: () => import('../views/coupon/sold.vue')
            }
        }, {
            path: '/coupon/soldInfo',
            meta: {
                title: '券详情',
            },
            components: {
                mains: () => import('../views/coupon/soldInfo.vue')
            }
        }]
    }, {
        path: '/brand',
        component: () => import('../views/public.vue'),
        redirect: '/brand/index',
        children: [{
            path: '/brand/index',
            meta: {
                title: '品牌管理',
                keepAlive: true,
                name: 'brand'
            },
            components: {
                mains: () => import('../views/brand/index.vue')
            }
        }, {
            path: '/banner/index',
            meta: {
                title: '首页轮播图',
                keepAlive: true,
                name: 'banner'
            },
            components: {
                mains: () => import('../views/banner/index.vue')
            }
        }]
    }, {
        path: '/order',
        component: () => import('../views/public.vue'),
        redirect: '/order/purchase/index',
        children: [{
            path: '/order/purchase/index',
            meta: {
                title: '购券订单',
                keepAlive: true,
                name: 'purchase'
            },
            components: {
                mains: () => import('../views/order/purchase/index.vue')
            }
        }, {
            path: '/order/purchase/info',
            meta: {
                title: '订单详情',
            },
            components: {
                mains: () => import('../views/order/purchase/info.vue')
            }
        }, {
            path: '/order/write/index',
            meta: {
                title: '核销订单',
                keepAlive: true,
                name: 'write'
            },
            components: {
                mains: () => import('../views/order/write/index.vue')
            }
        }, {
            path: '/order/write/info',
            meta: {
                title: '核销订单详情',
            },
            components: {
                mains: () => import('../views/order/write/info.vue')
            }
        }, {
            path: '/order/refund/index',
            meta: {
                title: '退款订单',
                keepAlive: true,
                name: 'refund'
            },
            components: {
                mains: () => import('../views/order/refund/index.vue')
            }
        }, {
            path: '/order/refund/info',
            meta: {
                title: '退款订单详情',
            },
            components: {
                mains: () => import('../views/order/refund/info.vue')
            }
        }, ]
    },
    {
        path: '/user',
        redirect: '/user/index',
        component: () => import('../views/public.vue'),
        children: [{
            path: '/user/index',
            meta: {
                title: '用户管理',
                keepAlive: true,
                name: 'user'
            },
            components: {
                mains: () => import('../views/user/index.vue')
            }
        }, {
            path: '/user/info',
            meta: {
                title: '用户详情',
            },
            components: {
                mains: () => import('../views/user/info.vue')
            }
        }]
    },
    {
        path: '/channel',
        component: () => import('../views/public.vue'),
        redirect: '/channel/index',
        children: [{
            path: '/channel/index',
            meta: {
                title: '渠道管理',
                keepAlive: true,
                name: 'channel_manage'
            },
            components: {
                mains: () => import('../views/channel/index.vue')
            }
        }, {
            path: '/channel/add',
            meta: {
                title: '新增渠道',
            },
            components: {
                mains: () => import('../views/channel/add.vue')
            }
        }, {
            path: '/channel/edit',
            meta: {
                title: '编辑渠道',
            },
            components: {
                mains: () => import('../views/channel/add.vue')
            }
        }, {
            path: '/channel/info',
            meta: {
                title: '渠道详情',
            },
            components: {
                mains: () => import('../views/channel/info.vue')
            }
        }, {
            path: '/channel/coupon',
            meta: {
                title: '渠道详情',
            },
            components: {
                mains: () => import('../views/channel/coupon.vue')
            }
        }, {
            path: '/channel/account/index',
            meta: {
                title: '渠道账号',
                keepAlive: true,
                name: 'channel_account'
            },
            components: {
                mains: () => import('../views/channel/account/index.vue')
            }
        }, {
            path: '/channel/account/add',
            meta: {
                title: '新增渠道账号',
            },
            components: {
                mains: () => import('../views/channel/account/add.vue')
            }
        }, {
            path: '/channel/account/edit',
            meta: {
                title: '编辑渠道账号',
            },
            components: {
                mains: () => import('../views/channel/account/add.vue')
            }
        }, {
            path: '/channel/account/info',
            meta: {
                title: '渠道账号详情',
            },
            components: {
                mains: () => import('../views/channel/account/info.vue')
            }
        }, {
            path: '/channel/fund/index',
            meta: {
                title: '账户资金',
                keepAlive: true,
                name: 'channel_fund'
            },
            components: {
                mains: () => import('../views/channel/fund/index.vue')
            }
        }, {
            path: '/channel/fund/info',
            meta: {
                title: '资金明细',
                keepAlive: true,
                name: 'channel_fund_detail'
            },
            components: {
                mains: () => import('../views/channel/fund/info.vue')
            }
        }, {
            path: '/channel/fund/add',
            meta: {
                title: '资金变动',
            },
            components: {
                mains: () => import('../views/channel/fund/add.vue')
            }
        }]
    }, {
        path: '/settlement',
        component: () => import('../views/public.vue'),
        redirect: '/settlement/store/index',
        children: [{
            path: '/settlement/store/index',
            meta: {
                title: '门店结算',
                name: 'store_settlement',
                keepAlive: true
            },
            components: {
                mains: () => import('../views/settlement/store/index.vue')
            }
        }, {
            path: '/settlement/store/info',
            meta: {
                title: '结算详情',
            },
            components: {
                mains: () => import('../views/settlement/store/info.vue')
            }
        },{
            path: '/settlement/channel/index',
            meta: {
                title: '渠道结算',
                name: 'channel_settlement',
                keepAlive: true
            },
            components: {
                mains: () => import('../views/settlement/channel/index.vue')
            }
        }, {
            path: '/settlement/channel/info',
            meta: {
                title: '结算详情',
            },
            components: {
                mains: () => import('../views/settlement/channel/info.vue')
            }
        }]
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

// 确保在内页时刷新页面导致vuex中存储的权限列表没了无法判断
router.beforeEach((to, form, next) => {
    if (to.path == '/login' || !method.getToken()) {
        return next()
    }
    let operation = store.state.operation
    if (!Object.keys(operation).length) {
        getCurrentMenu().then(res => {
            store.commit('setOperation', res.operation)
            next()
        })
    } else {
        next()
    }
})

router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    if (isChunkLoadFailed) {
        location.reload();
    }
});
export default router